export const TERMS_VERSION = "1.0";
export const TERMS_EFFECTIVE = "June 2026";

export const TERMS_SECTIONS = [
  {
    title: "1. Services",
    body: "Mason's Mobile Mechanic (\"we,\" \"us\") provides mobile automotive diagnostic, maintenance, and repair services at the customer's location throughout the Las Vegas Valley, as well as arranged drop-off service. All services are performed by appointment or on-demand availability.",
  },
  {
    title: "2. Estimates & Pricing",
    body: "Quotes provided by phone, text, or online are good-faith estimates based on the information you provide. Final pricing is confirmed after diagnosis and before any repair work begins. You will never be charged for repair work you did not approve.",
  },
  {
    title: "3. Repair Authorization",
    body: "By scheduling service or submitting a service request, you authorize Mason's Mobile Mechanic to inspect, diagnose, and perform the requested services on your vehicle. You confirm that you are the owner of the vehicle or are authorized by the owner to approve service.",
  },
  {
    title: "4. Additional Repairs",
    body: "If additional problems are discovered during service, we will notify you with a description and price before performing any additional work. Additional repairs require your separate approval (verbal, text, or written).",
  },
  {
    title: "5. Parts",
    body: "We use quality OEM-equivalent or better parts unless otherwise agreed. Customer-supplied parts may be installed at our discretion; we are not responsible for the performance or failure of customer-supplied parts.",
  },
  {
    title: "6. Payment",
    body: "Payment is due upon completion of service unless otherwise agreed in advance. We accept cash, major credit/debit cards, Zelle, Venmo, Cash App, and secure online payment. Diagnostic fees, when applicable, are quoted up front.",
  },
  {
    title: "7. Vehicle Condition & Access",
    body: "You agree to provide safe and legal access to the vehicle. We reserve the right to decline or stop work if conditions are unsafe, if the vehicle has pre-existing damage that prevents proper repair, or if the requested work cannot be completed properly in a mobile setting.",
  },
  {
    title: "8. Scheduling & Cancellations",
    body: "Please provide at least 2 hours' notice to cancel or reschedule an appointment. Repeated no-shows may require prepayment for future bookings.",
  },
  {
    title: "9. Limitation of Liability",
    body: "Our liability for any claim arising from services performed is limited to the amount paid for those services. We are not responsible for pre-existing conditions, unrelated failures, or consequential damages such as towing, rental cars, or lost time, except where required by law.",
  },
  {
    title: "10. Contact",
    body: "Questions about these terms? Call or text (404) 749-7063. These terms may be updated from time to time; the version in effect at the time of your acceptance applies to your service.",
  },
];

export const ACCEPTANCE_TEXT =
  "I have read and agree to Mason's Mobile Mechanic's Terms of Service and Repair Authorization. I authorize Mason's Mobile Mechanic to inspect, diagnose, and perform the requested services on my vehicle.";
